import React from 'react';
import {
    ArrayInput,
    AutocompleteInput,
    Edit,
    FormTab,
    FormDataConsumer,
    NumberInput,
    ReferenceInput,
    ReferenceArrayInput,
    SelectArrayInput,
    required,
    SelectInput,
    SimpleFormIterator,
    TabbedForm,
    TextInput,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import Icon from '@material-ui/icons/Bookmark';

export const ConfigIcon = Icon;

const ConfigTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>{record ? `${record.CustomerName} - ${record.CustomerConfigDescription} ` : ''}</span>;
};


export const styles = {
    source: {  marginLeft: 32 },
    codec: { maxWidth:'4em', fontSize: '1em' },
    codecForm: { display: 'inline-block'},
    profile: { maxWidth: '4em', fontSize: '1em' },
    profileForm: {display: 'inline-block', marginLeft: 10},
    rateMode: { maxWidth: '5em', fontSize: '1em' },
    rateModeForm: {display: 'inline-block', marginLeft: 10},
    qualityLevel: { maxWidth: '5em', fontSize: '1em' },
    qualityLevelForm: {display: 'inline-block', marginLeft: 10},
    hResolution: { maxWidth: '5em', fontSize: '1em' },
    hResolutionForm: {display: 'inline-block', marginLeft: 10},
    vResolution: { maxWidth: '5em', fontSize: '1em' },
    vResolutionForm: {display: 'inline-block', marginLeft: 10},
    Resolution: { maxWidth: '7em', fontSize: '1em' },
    ResolutionForm: {display: 'inline-block', marginLeft: 10},
    frameRate: { maxWidth: '5em', fontSize: '1em' },
    frameRateForm: {display: 'inline-block', marginLeft: 10},
    esrate: { maxWidth: '5em', fontSize: '1em' },
    esrateForm: {display: 'inline-block', marginLeft: 10},
    processingDelay: { maxWidth: '8em', fontSize: '1em'},
    processingDelayForm: { display: 'inline-block', marginLeft: 32},
    count: { maxWidth: '5em',  fontSize: '1em' },
    countForm: { display: 'inline-block', marginLeft: 32 },
    width: { width: '5em' },
    processingSettings: { width: 550, marginLeft: 32, fontSize: '1em' },
    delay: { width: 600, marginLeft: 32, fontSize: '1em' },
    ABRProcessings: { width:2000, marginLeft: 64, fontSize: '1em' },
};

const validateCustomerId = [required()];
const validateDescription = [required()];
const validateSource = [required()];
const validateCodec = [required()];
const validateCQ = [required()];
const validateProfile = [required()];
const validateRateMode = [required()];
const validatehRes = [required()];
const validatevRes = [required()];
const validateFrameRate = [required()];
const validateEsRate = [required()];


const ConfigEdit = ({ classes, ...props }) => (
    <Edit {...props} title={<ConfigTitle />} >
        <TabbedForm undoable={false}>
            <FormTab label="Input">
                <FormDataConsumer>
                    { ({ formData, ...rest }) => formData.CustomerConfigStatus !== "CREATED" &&
                        <p>After submission the configuration can not be changed anymore</p>
                    }
                </FormDataConsumer>

                <FormDataConsumer>
                    { ({ formData, ...rest }) => formData.CustomerConfigStatus === "CREATED" &&
                        <ReferenceInput
                            label="Customer Name"
                            validate={validateCustomerId}
                            source="CustomerId"
                            reference="customer">
                            <SelectInput optionText="CustomerName" />
                        </ReferenceInput>
                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    { ({ formData, ...rest }) => formData.CustomerConfigStatus === "CREATED" &&
                        <TextInput label="Description" source="CustomerConfigDescription" validate={validateDescription}/>
                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    { ({ formData, ...rest }) => formData.CustomerConfigStatus === "CREATED" &&
                        <AutocompleteInput
                            label="Source"
                            validate={validateSource}
                            source="config.ChannelMix[0].Channel.inputService.source.tsfileSettings.source.fileName"
                            choices={[
                                {id: 'Cisco IBC 2016 480i.ts', name: '480i'},
                                {id: 'Cisco IBC 2016 576i.ts', name: '576i'},
                                {id: 'Cisco IBC 2016 720p50.ts', name: '720p50'},
                                {id: 'Cisco IBC 2016 720p60.ts', name: '720p60'},
                                {id: 'Cisco IBC 2016 1080i25.ts', name: '1080i25'},
                                {id: 'Cisco IBC 2016 1080i30.ts', name: '1080i30'},
                                {id: 'Cisco IBC 2016 1080p50.ts', name: '1080p50'},
                                {id: 'Cisco IBC 2016 1080p60.ts', name: '1080p60'},
                                {id: 'Cisco IBC 2016 2160p50.ts', name: '2160p50'},
                                {id: 'Cisco IBC 2016 2160p60.ts', name: '2160p60'}
                            ]}
                            formClassName={classes.source}/>
                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    {
                        ({ formData, ...rest}) => formData.CustomerConfigStatus === "CREATED" &&
                            <ArrayInput label="First screen" source="config.ChannelMix[0].Channel.CBRProcessings" style={{ width: 850, marginLeft: 48 }}>
                                <SimpleFormIterator >
                                    <AutocompleteInput
                                        label="codec"
                                        validate={validateCodec}
                                        source="videoSettings.codec"
                                        choices={[
                                            {id: 'H.265', name: 'H.265'},
                                            {id: 'H.264', name: 'H.264'},
                                            {id: 'MPEG2', name: 'MPEG2'},
                                        ]}
                                        className={classes.codec}
                                        formClassName={classes.codecForm}/>
                                    <AutocompleteInput
                                        label="Profile"
                                        validate={validateProfile}
                                        source="videoSettings.profile"
                                        choices={[
                                            {id: 'Main10', name: 'Main10'},
                                            {id: 'Main', name: 'Main'},
                                            {id: 'High', name: 'High'},
                                            {id: 'Baseline', name: 'Baseline'}]}
                                        className={classes.profile}
                                        formClassName={classes.profileForm}/>
                                    <AutocompleteInput
                                        label="Mode"
                                        validate={validateRateMode}
                                        defaultValue={'CBR'}
                                        source="videoSettings.rateMode"
                                        choices={[
                                            {id: 'CBR', name: 'CBR'},
                                            {id: 'Smart', name: 'Smart'}]}
                                        className={classes.rateMode}
                                        formClassName={classes.rateModeForm}/>
                                    <NumberInput
                                        label="CQ"
                                        inputProps={{step:1, min:18, max:30}}
                                        defaultValue={28}
                                        validate={validateCQ}
                                        source="videoSettings.qualityLevel"
                                        className={classes.qualityLevel}
                                        formClassName={classes.qualityLevelForm}/>
                                    <AutocompleteInput
                                        label="Resolution"
                                        validate={validateFrameRate}
                                        source="videoSettings.resolution"
                                        choices={[
                                            {id: 'Follow Input', name: 'Follow Input'},
                                            {id: 'SD', name: 'SD'}
                                        ]}
                                        className={classes.Resolution}
                                        formClassName={classes.ResolutionForm}/>
                                    <NumberInput
                                        label="esRate"
                                        validate={validateEsRate}
                                        source="videoSettings.esRate"
                                        className={classes.esrate}
                                        formClassName={classes.esrateForm}/>
                                </SimpleFormIterator>
                            </ArrayInput>

                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    { ({ formData, ...rest }) => formData.CustomerConfigStatus === "CREATED" &&
                        <ArrayInput label="ABR profiles" source="config.ChannelMix[0].Channel.ABRProcessings[0].videoSettings.profiles" style={{ width: 850, marginLeft: 48 }}>
                            <SimpleFormIterator >
                                <AutocompleteInput
                                    label="codec"
                                    validate={validateCodec}
                                    source="codec"
                                    choices={[
                                        {id: 'H.265', name: 'H.265'},
                                        {id: 'H.264', name: 'H.264'}]}
                                    className={classes.codec}
                                    formClassName={classes.codecForm}/>
                                <AutocompleteInput
                                    label="Profile"
                                    validate={validateProfile}
                                    source="profile"
                                    choices={[
                                        {id: 'Main10', name: 'Main10'},
                                        {id: 'Main', name: 'Main'},
                                        {id: 'High', name: 'High'}]}
                                    className={classes.profile}
                                    formClassName={classes.profileForm}/>
                                <AutocompleteInput
                                    label="Mode"
                                    validate={validateRateMode}
                                    defaultValue={'CBR'}
                                    source="rateMode"
                                    choices={[
                                        {id: 'CBR', name: 'CBR'},
                                        {id: 'Smart', name: 'Smart'}]}
                                    className={classes.rateMode}
                                    formClassName={classes.rateModeForm}/>
                                <NumberInput
                                    label="CQ"
                                    inputProps={{step:1, min:18, max:30}}
                                    defaultValue={28}
                                    validate={validateCQ}
                                    source="qualityLevel"
                                    className={classes.qualityLevel}
                                    formClassName={classes.qualityLevelForm}/>
                                <NumberInput
                                    label="hRes"
                                    validate={validatehRes}
                                    source="hResolution"
                                    className={classes.hResolution}
                                    formClassName={classes.hResolutionForm}/>
                                <NumberInput
                                    label="vRes"
                                    validate={validatevRes}
                                    source="vResolution"
                                    className={classes.vResolution}
                                    formClassName={classes.vResolutionForm}/>
                                <AutocompleteInput
                                    label="fps"
                                    validate={validateFrameRate}
                                    source="frameRate"
                                    choices={[
                                        {id: '9.99', name: '9.99p'},
                                        {id: '11.99', name: '11.99p'},
                                        {id: '12.5', name: '12.5p'},
                                        {id: '14.99', name: '14.99p'},
                                        {id: '23.98', name: '23.98p'},
                                        {id: '25', name: '25p'},
                                        {id: '29.97', name: '29.97p'},
                                        {id: '50', name: '50p'},
                                        {id: '59.94', name: '59.94p'}
                                    ]}
                                    className={classes.frameRate}
                                    formClassName={classes.frameRateForm}/>
                                <NumberInput
                                    label="esRate"
                                    validate={validateEsRate}
                                    source="esRate"
                                    className={classes.esrate}
                                    formClassName={classes.esrateForm}/>
                            </SimpleFormIterator>
                        </ArrayInput>
                    }
                </FormDataConsumer>
            </FormTab>
            <FormTab label="Shared with">
                <FormDataConsumer>
                    { ({ formData, ...rest }) => formData.CustomerConfigStatus !== "SUCCEEDED" &&
                        <p>Test must be succeeded before it can be shared</p>
                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    { ({ formData, ...rest }) => formData.CustomerConfigStatus === "SUCCEEDED" &&
                        <ReferenceArrayInput
                            label="Share with"
                            source="UserList"
                            perPage={100}
                            sort={{ field: 'UserId', order: 'ASC' }}
                            reference="user">
                        <SelectArrayInput optionText="UserId" />
                    </ReferenceArrayInput>
                    }
                </FormDataConsumer>
            </FormTab>
            <FormTab label="TCO Information">
                <NumberInput
                    label="Channel Count"
                    inputProps={{step:1, min:1}}
                    defaultValue={50}
                    source="DeployedChannels" />
            </FormTab>
        </TabbedForm>
    </Edit>
);

export default withStyles(styles)(ConfigEdit);